import { WizardMedication } from '@/types/medication';
import { Card } from '@/components/ui/card';
import { NameStep } from '../wizard-steps/NameStep';
import { FormStep } from '../wizard-steps/FormStep';
import { DosageStep } from '../wizard-steps/DosageStep';
import { PatternStep } from '../wizard-steps/pattern/PatternStep';
import { CycleStep } from '../wizard-steps/CycleStep';
import { FoodInstructionsStep } from '../wizard-steps/FoodInstructionsStep';

interface StepContentProps {
  step: number;
  currentMedication: WizardMedication;
  selectedMedications: number[];
  updateCurrentMedication: (medication: WizardMedication) => void;
}

export const StepContent = ({
  step,
  currentMedication,
  selectedMedications,
  updateCurrentMedication,
}: StepContentProps) => {
  switch (step) {
    case 1:
      return (
        <Card className="p-4 space-y-6">
          <NameStep medication={currentMedication} onChange={updateCurrentMedication} />
          <DosageStep medication={currentMedication} onChange={updateCurrentMedication} />
          <FormStep medication={currentMedication} onChange={updateCurrentMedication} />
        </Card>
      );
    case 2:
      return (
        <Card className="p-4 space-y-6">
          <PatternStep medication={currentMedication} onChange={updateCurrentMedication} />
        </Card>
      );
    case 3:
      return (
        <Card className="p-4">
          <FoodInstructionsStep medication={currentMedication} onChange={updateCurrentMedication} />
        </Card>
      );
    default:
      return null;
  }
};